import Select from "react-select";
import { SelectFamilyRelationshipProps } from "./types";

export const SelectFamilyRelationship = ({
  options,
  id,
  name,
  error,
  value,
  handleChange,
  placeholder,
  disabled,
}: SelectFamilyRelationshipProps) => {

  const getValue = (value: number) => {
    return options.filter((o) => value === o.id);
  }

  return (
    <div className={`field-holder ${error ? "field-holder-invalid" : ""}`}>
      <Select
        menuPosition="fixed"
        classNamePrefix="react-select"
        className="react-select input _opacity-gray"
        id={id}
        value={getValue(value)}
        onChange={(selectedOption) => {
          const event: any = {
            target: {
              name,
              value: selectedOption ? selectedOption.id : 0,
            },
          };
          handleChange(event);
        }}
        options={options}
        placeholder={placeholder}
        isSearchable
        loadingMessage={() => 'Carregando...'}
        noOptionsMessage={() => "Nenhuma opção encontrada"}
        getOptionValue={(option) => option.label}
        getOptionLabel={(option) => option.label}
        name={name}
        isDisabled={disabled}
      />
      {error !== "" && (
        <span
          className='error-message error-without-label'
        >
          {error}
        </span>
      )}
    </div>
  )
}